// Stripe configuration for the React app
export const STRIPE_CONFIG = {
  publishableKey: process.env.REACT_APP_STRIPE_PK_PROD || process.env.REACT_APP_STRIPE_PK_TEST || 'pk_test_placeholder',
  functionsUrl: (() => {
    // Check if we're running on localhost (development) or production
    const isLocalhost = typeof window !== 'undefined' && 
      (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');
    
    if (isLocalhost) {
      return process.env.REACT_APP_FUNCTIONS_URL || 'http://localhost:5001/carly-faye-foundation/us-central1';
    } else {
      return 'https://us-central1-carly-faye-foundation.cloudfunctions.net';
    }
  })()
};

// Environment detection
export const isDevelopment = process.env.NODE_ENV === 'development';
export const isProduction = process.env.NODE_ENV === 'production';

// Stripe product configuration
export const DONATION_AMOUNTS = [
  { value: 25, label: '$25' },
  { value: 50, label: '$50' },
  { value: 100, label: '$100' },
  { value: 250, label: '$250' }
];

// Custom donation amount validation
export const validateDonationAmount = (amount: number): boolean => {
  return amount >= 1 && amount <= 10000; // $1 to $10,000
}; 